/**
 * Shared types for report dashboards
 */
export {};
